import { SVGProps } from "react";

const TransferIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="current"
    stroke="current"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.512 12c0 6.338 5.152 11.49 11.49 11.49s11.49-5.152 11.49-11.49a.807.807 0 0 0-.802-.802.807.807 0 0 0-.802.802c0 5.45-4.435 9.887-9.886 9.887S2.115 17.45 2.115 12c0-5.451 4.436-9.887 9.887-9.887a.807.807 0 0 0 .801-.802.807.807 0 0 0-.801-.801C5.664.51.512 5.662.512 12Zm21.377-6.413c0 .438.363.801.801.801a.807.807 0 0 0 .802-.801V1.31a.79.79 0 0 0-.1-.384.789.789 0 0 0-.34-.33.79.79 0 0 0-.362-.087h-4.275a.807.807 0 0 0-.802.801c0 .439.364.802.802.802h2.34l-3.976 3.976a.807.807 0 0 0 0 1.133c.16.16.363.235.566.235a.793.793 0 0 0 .567-.235l3.977-3.977v2.342ZM8.615 13.43v4.32h1.31v-4.32h1.984l1.597 4.32h1.764v-4.32h1.311v-1.076h-1.31v-1.378h1.31V9.901h-1.31V5.749h-1.328v4.152h-1.984l-1.596-4.152H8.615v4.152H7.304v1.075h1.31v1.378h-1.31v1.076h1.31Zm2.89-1.076h-1.58l-.033-1.378h1.11l.504 1.378Zm2.505 3.026h-.067l-.69-1.95h.706l.05 1.95ZM10.598 9.9h-.706l-.067-2.083h.067l.706 2.084Zm3.378 2.454H12.85l-.504-1.378h1.597l.033 1.378Z"
    />
  </svg>
);

export default TransferIcon;
